import { createFileRoute } from '@tanstack/react-router';

import {
  channelsSearchSchema,
  PinterestConnectionPage,
  socialConnectionsQueryOptions,
} from '@/features/social';
import { storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest/connection')({
  staticData: { crumb: 'social:nav.connection' },
  validateSearch: channelsSearchSchema,
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.query({
        ...socialConnectionsQueryOptions(params.storeId),
        staleTime: 'static',
      }),
      context.queryClient.query({ ...storeQueryOptions(params.storeId), staleTime: 'static' }),
    ]).catch(() => undefined),
  component: ConnectionRoute,
});

function ConnectionRoute() {
  const { connected, error } = Route.useSearch();
  return <PinterestConnectionPage connected={connected} error={error} />;
}
